export default __webpack_public_path__ + "static/media/unauthorized.6be73627.png";